import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { ConfirmComponent } from '../../../shared/components/confirm-dialog/confirm.component';
import { MessageComponent } from '../../../shared/components/message-dialog/message-dialog.component';
import {
  ConfirmDialogModel,
  MessageDialogModel,
  successDialogModel,
} from '../../_models/confirm-dialog.model';
import { SuccessDialogComponent } from 'src/app/shared/components/success-dialog/success-dialog.component';
import { IafCalculatorData, IafCalculatorDialogComponent } from 'src/app/dashboard/components/t-one-dashboard/components/t1-report-payment/components/iaf-calculator-dialog/iaf-calculator-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class ConfirmDialogService {
  [x: string]: any;
  constructor(private dialog: MatDialog) {}

  confirmDialog(data: ConfirmDialogModel): Observable<boolean> {
    return this.dialog
      .open(ConfirmComponent, {
        data,
        width: '450px',
        disableClose: true,
      })
      .afterClosed();
  }

  messageDialog(data: MessageDialogModel): Observable<boolean> {
    return this.dialog
      .open(MessageComponent, {
        data,
        width: '450px',
        disableClose: true,
      })
      .afterClosed();
  }

  successDialog(data: successDialogModel): Observable<boolean> {
    return this.dialog
      .open(SuccessDialogComponent, {
        data,
        width: '450px',
        disableClose: true,
      })
      .afterClosed();
  }

  iafCalculatorDialog(data: IafCalculatorData): Observable<boolean> {
    return this.dialog
      .open(IafCalculatorDialogComponent, {
        data,
        width: '400px',
        disableClose: true,
      })
      .afterClosed();
  }
}
